<template>
  <div class="bg-white dark:bg-gray-800 rounded-lg p-5 flex flex-col w-full mt-6 gap-4" dir="ltr">
    <canvas class="max-h-72" id="evaluations-chart" ref="evaluationsPieChart"></canvas>
  </div>
</template>

<script setup lang="ts">
import { Chart, type ChartData, type ChartTypeRegistry } from 'chart.js'
import { onMounted, ref, shallowRef, toRefs, watch } from 'vue'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import type { Evaluation } from '@/types/global'
import { isSupportedPresenceEvaluation } from '@/utils/evaluationPresence'

const props = defineProps<{
  evaluations: Evaluation[]
}>()

const { evaluations } = toRefs(props)

const evaluationsPieChart = ref<HTMLCanvasElement | null>(null)

let evaluationsChart = shallowRef<
  Chart<keyof ChartTypeRegistry, (number | [number, number] | null)[], unknown> | undefined
>(undefined)

watch(evaluations, () => {
  if (evaluationsChart.value) {
    evaluationsChart.value.data = getAttendanceChartData(evaluations.value)
    evaluationsChart.value.update()
  }
})

function getAttendanceChartData(evaluations: Evaluation[]): ChartData<'pie'> {
  // Define attendance categories
  const attendanceCounts = {
    present: 0,
    absent: 0
  }

  // Count occurrences of each presence type
  evaluations.filter(isSupportedPresenceEvaluation).forEach((evaluation) => {
    attendanceCounts[evaluation.presence_type]++
  })

  const total = Object.values(attendanceCounts).reduce((sum, count) => sum + count, 0)

  // Calculate percentages
  const labels = Object.entries(attendanceCounts).map(([key, value]) => {
    const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0'

    const translations = {
      present: 'حضور',
      absent: 'غياب'
    }
    //@ts-ignore
    return `${translations[key]} ${value} (${percentage}%)`
  })

  // Return the data in Chart.js format
  return {
    labels,

    datasets: [
      {
        label: 'Attendance Distribution',
        data: Object.values(attendanceCounts),
        backgroundColor: ['#22C55E', '#EF4444'],
        borderWidth: 1
      }
    ]
  }
}

onMounted(() => {
  if (evaluationsPieChart.value) {
    evaluationsChart.value = new Chart(evaluationsPieChart.value, {
      type: 'pie',
      plugins: [ChartDataLabels],
      options: {
        responsive: true
        // plugins: {
        //   datalabels: {
        //     borderColor: 'white',
        //     borderRadius: 5,
        //     borderWidth: 2,
        //     color: 'white',
        //     font: {
        //       weight: 'bold'
        //       // size : 5
        //     },
        //     padding: 6,

        //   }
        // }
      },
      data: getAttendanceChartData(evaluations.value)
    })
  }
})
</script>

<style scoped></style>
